<template>
  <div class="wrap">
    <b-navbar
      id="nav"
      type="dark"
      fixed="top"
      toggleable="lg"
      :class="scrollTop >= 200 || flag ? 'nav-active' : ''"
    >
      <b-container>
        <b-navbar-brand href="#">
          <img
            :src="basicInfo.logo"
            alt=""
            :style="screenWidth >= 992 ? 'width: 6rem; height: 3.5rem;' : 'width: 58px;height: 30px;margin: 4px 20px;' "
          />
        </b-navbar-brand>
        <div v-show="screenWidth >= 992 ? true : false" class="mini-input">
          <input
            class="mini-search"
            type="text"
            :placeholder="$t('lang.inputPe')"
          />
          <b-icon
            icon="search"
            width="1.4rem"
            height="1.4rem"
            style="margin: 0 0.5rem; color: #ffffff"
          >
          </b-icon>
        </div>
        <b-navbar-toggle
          @click="toggleClick"
          target="nav-collapse"
        ></b-navbar-toggle>
        <b-collapse ref="collapsePart" id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <template v-for="(item, index) in menu">
              <template v-if="item.submenu">
                <b-nav-item-dropdown
                  @click.native="navigato(item.path)"
                  :key="index"
                >
                  <template slot="button-content">
                    <div
                      @click="
                        linkto(
                          $event,
                          item.path,
                          screenWidth < 992 ? minScreen : ''
                        )
                      "
                    >
                      {{ getTitle(item.text) }}
                    </div>
                  </template>
                  <b-dropdown-item
                    v-for="(subItem, subIndex) in item.submenu"
                    :key="subIndex"
                    @click.stop.native="
                      linkto(
                        $event,
                        subItem.path,
                        screenWidth < 992 ? minScreen : ''
                      )
                    "
                    >{{
                      item.text == "whatWeDo" || item.text == "futrueNews"
                        ? subItem.text
                        : getTitle(subItem.text)
                    }}
                  </b-dropdown-item>
                </b-nav-item-dropdown>
              </template>
              <template v-else>
                <b-nav-item
                  :key="index"
                  @click="
                    linkto(
                      $event,
                      item.path,
                      screenWidth < 992 ? minScreen : ''
                    )
                  "
                  >{{ getTitle(item.text) }}</b-nav-item
                >
              </template>
            </template>

            <b-nav-item @click="changeLanguage">{{
              $t("lang.lang")
            }}</b-nav-item>
            <div v-show="screenWidth > 992 ? false : true" class="mini-input">
              <input
                class="mini-search"
                type="text"
                placeholder="SEARCH"
                style="
                  background: transparent;
                  border: none;
                  padding: 0.5rem 0.5rem;
                  width: 100%;
                "
              />
              <b-icon
                icon="search"
                width="1.5rem"
                height="1.5rem"
                style="margin-right: 1rem"
              ></b-icon>
            </div>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
    <banner></banner>
    <router-view />
  </div>
</template>
<script>
import banner from "@/forumcomponents/banner";
export default {
  inject: ["reload"], //注入reload方法
  data() {
    return {
      timer: null,
      screenWidth: document.body.clientWidth,
      scrollTop: 0,
      flag: false,
      langFlag: false,
      basicInfo: {},
      menu: [
        {
          text: "Home",
          path: "/forum/index",
        },
        {
          text: "About",
          path: "/forum/about/intro?index=0",
          submenu: [
            {
              // text: '简介',
              text: "fminiAboutUs",
              path: "/forum/about/intro?index=0",
            },
            {
              // text: '愿景使命',,
              text: "VandM",
              path: "/forum/about/vision?index=1",
            },
            {
              // text: '科学委员会',
              text: "Sciencecommittee",
              path: "/forum/about/committee?index=2",
            },
            {
              // text: '理事会',
              text: "Council",
              path: "/forum/about/council?index=3",
            },
            {
              // text: '机构理事',
              text: "InstitutionalCouncil",
              path: "/forum/about/institutional?index=4",
            },
            {
              // text: '青年理事会',
              text: "YouthCouncil",
              path: "/forum/about/YouthCouncil?index=5",
            },
            {
              // text: '青创联盟',
              text: "YOSIA",
              path: "/forum/about/YOSIA?index=6",
            },
          ],
        },
        {
          text: "futureSience",
          path: "/index",
        },
        {
          text: "whatWeDo",
          path: "/forum/project/list?type=1&index=0",
          submenu: [],
          // submenu: [
          //   {
          //     // text: '未来科学大奖科学峰会',
          //     text: "FSPSymposium",
          //     path: "/forum/project/list?type=1&index=0",
          //   },
          //   {
          //     // text: '理解未来科学讲座',
          //     text: "FLSeries",
          //     path: "/forum/project/list?type=2&index=1",
          //   },
          //   {
          //     text: "FutureRoundtable",
          //     // text: '闭门羹',
          //     path: "/forum/project/list?type=3&index=2",
          //   },
          //   {
          //     // text: '未来局',
          //     text: "FutureReception",
          //     path: "/forum/project/list?type=4&index=3",
          //   },
          //   {
          //     text: "YOSIAWebinar",
          //     path: "/forum/project/list?type=5&index=4",
          //   },
          //   {
          //     // text: '病毒与人类健康专题科普',
          //     text: "viuuesHuman",
          //     path: "/forum/project/list?type=6&index=5",
          //   },
          //   {
          //     // text: '城市峰会',
          //     text: "cityMeeting",
          //     path: "/forum/project/citySummit",
          //   },
          // ],
        },
        {
          text: "futrueNews",
          path: "/forum/news/lastest?index=0",
          submenu: [],
          // submenu: [{
          //     // text: '未来新闻',
          //     text: "futureNew",
          //     path: "/forum/news/list?type=1",
          //   },
          //   {
          //     // text: '媒体报道',
          //     text: "mediaNew",
          //     path: "/forum/news/list?type=2",
          //   },
          //   {
          //     // text: 'AI+科学系列',
          //     text: "AIscience",
          //     path: "/forum/news/list?type=3",
          //   },
          // ],
        },
        {
          text: "contactUs",
          path: "/forum/contact/list?type=6&typeId=9",
          submenu: [
            {
              // text: '合作支持',
              text: "cooparationSupport",
              path: "/forum/contact/list?type=0&typeId=3",
            },
            {
              // text: '媒体支持',
              text: "mediaSupport",
              path: "/forum/contact/list?type=1&typeId=4",
            },
            {
              // text: '学术合作机构',
              text: "amedemicConcil",
              path: "/forum/contact/list?type=2&typeId=5",
            },
            {
              // text: '志愿者报名',
              text: "VoluteerSign",
              path: "/forum/contact/list?type=3&mode=signup&typeId=6&volunteer=1",
            },
            {
              // text: '实习生报名',
              text: "traineeSign",
              path: "/forum/contact/list?type=4&mode=signup&typeId=7&volunteer=2",
            },
            {
              // text: '全职工作',
              text: "FulltimeJob",
              path: "/forum/contact/list?type=5&mode=signup&typeId=8&volunteer=3",
            },
            {
              // text: '联系我们',
              text: "contact",
              path: "/forum/contact/list?type=6&typeId=9",
            },
          ],
        },
      ],
    };
  },
  created() {
    localStorage.getItem("LANG") == "cn" || !localStorage.getItem("LANG")
      ? ((this.$i18n.locale = "cn"), (this.langFlag = false))
      : ((this.$i18n.locale = "en"), (this.langFlag = true));
    this.getNav();
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
    window.addEventListener("scroll", this.handleScroll, true);
  },
  destroyed() {
    this.langFlag
      ? localStorage.setItem("LANG", "en")
      : localStorage.setItem("LANG", "cn");
  },
  computed: {
    //监听 全局变量screenWidth
    listebScreenWidth() {
      return this.$store.state.screenWidth;
    },
  },
  watch: {
    listebScreenWidth(val) {
      this.screenWidth = val;
    },
  },

  methods: {
    getNav() {
      this.$forumApi.getBasic().then((res) => {
        if (res.code == 200) {
          if (res.data != null) {
            this.basicInfo = res.data;
            this.$store.state.footTxt = res.data.copyRight;
          }
        }
      });
      this.$forumApi.activityCategory().then((res) => {
        this.menu[3].submenu = res.data.map((item, index) => {
          if (item.type) {
            return {
              text: item.name,
              path: `/forum/project/citySummit`,
            };
          } else {
            return {
              text: item.name,
              path: `/forum/project/list?type=${item.id}&index=${index}`,
            };
          }
        });
      });
      this.$forumApi.newsCategoryPageList().then((res) => {
        console.log("anewsCategoryPageList", res.data);
        for (var i = 0; i < res.data.length; i++) {
          if (res.data[i].id == 6 || res.data[i].id == 3) {
            this.menu[4].submenu.push({
              text: res.data[i].name,
              id: res.data[i].id,
              path: `/forum/news/list?index=${i + 1}&typeId=${res.data[i].id}`,
            });
            continue;
          }
          this.menu[4].submenu.push({
            text: res.data[i].name,
            id: res.data[i].id,
            path: `/forum/news/lastest?index=${i + 1}&typeId=${res.data[i].id}`,
          });
        }
      });
    },
    //h5端的单行栏适配
    minScreen() {
      this.$refs.collapsePart.toggle();
      this.flag = !this.flag;
    },

    getTitle(title) {
      //中英文切换
      let str = "lang." + title;
      return this.$t(str);
    },
    search() {
      this.searchShow = !this.searchShow;
    },
    changeLanguage() {
      this.flag = !this.flag;
      this.langFlag = !this.langFlag;
      if (this.langFlag) {
        localStorage.setItem("LANG", "en");
      } else {
        localStorage.setItem("LANG", "cn");
      }
      this.$router.push("/");
      this.$router.push("/forum/index");
      this.reload(); //刷新
    },
    handleScroll() {
      this.scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
    },
    navigato(path) {
      this.$router.push(path);
    },
    linkto(e, path, fn) {
      fn ? fn() : "";
      this.$router.push(path);
    },
    toggleClick() {
      this.flag = !this.flag;
    },
  },
  components: {
    banner,
  },
};
</script>
<style lang="scss" scoped>
#nav {
  padding: 0.7rem;
  background: rgba(0, 0, 0, 0.2);

  a:focus {
    color: white;
  }
}

.search-input {
  display: flex;
  align-items: center;
  position: absolute;
  top: 3rem;
  right: -1rem;
  height: 2rem;
  line-height: 2rem;
  border: 1px solid #fff;
  border-radius: 10px;
  padding: 0 1rem;
  font-size: 1rem;
}

.search-flag {
  position: relative;
  display: none;
}

.input-fixed {
  top: 0rem;
  right: -1rem;
  background: #000;
}

input {
  color: #fff;
}

input::-webkit-input-placeholder {
  color: #fff;
}

.nav-active {
  background: #000 !important;
}

.navbar-dark .navbar-toggler {
  color: #ffffff;
  border: none;
}

.dropdown-menu {
  // border-radius: 0;
  text-align: center;
}

.dropdown-menu li {
  padding: 0.4rem 0rem;
  text-align: center;
}

.wrap::v-deep {
  .nav-item {
    padding: 0rem 0.3rem;

    a {
      padding: 0.5rem 1rem;
      color: #666666;
    }

    .nav-item:hover,
    .nav-item:focus {
      color: #fafafa !important;
      // background-color: #020202 !important;
    }
  }

  .dropdown-menu {
    padding: 0;
    background: transparent;
  }

  .navbar-dark .navbar-nav .nav-link {
    color: #ffffff !important;
  }

  .navbar-dark .navbar-nav .nav-link:hover,
  .navbar-dark .navbar-nav .nav-link:focus {
    // color: $forum-theme-blue !important;
  }

  .dropdown-item:hover,
  .dropdown-item:focus {
    color: $forum-theme-blue !important;
    background-color: #ffffff !important;
  }

  .dropdown-toggle::after {
    pointer-events: auto;
    display: inline-block;
    border: none;
    width: 1.2rem;
    height: 1.2rem;
    background: url(data:image/png;base64,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)
      center no-repeat;
    background-size: 100%;
  }

  .dropdown-toggle:focus::after {
    width: 1.2rem;
    height: 1.2rem;
    background: url(data:image/png;base64,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)
      center no-repeat;
    background-size: 100%;

    transform: rotate(180deg);
  }
}

.navbar-collapse.show {
  height: 100vh;
}

.mini-input {
  border: 1px solid #666666;
  display: flex;
  align-items: center;
  border-radius: 0.4rem;

  input::-webkit-input-placeholder {
    color: #666666;
  }
}

@media (max-width: 768px) {
  .wrap::v-deep {
    #nav{
      padding: 0.2rem;
    }
    .navbar-dark .navbar-nav .nav-link {
      display: flex;
      justify-content: space-between;
      padding: 7px 0px;
      transform: scale(0.9);
    }

    .nav-item a {
      text-align: left !important;
    }

    .mini-input{
      margin: 1.5rem 15px;
    }

    .dropdown-menu {
      text-align: left !important;
    }
  }
}

/* >= 992 */

@media (min-width: 992px) {
  .wrap::v-deep {
    .search-flag {
      display: inline;
      /* visibility: visible; */
    }

    .mini-input {
      border: 1px solid #fff;
      display: flex;
      align-items: center;
      border-radius: 0.6rem;
      width: 17rem;

      input {
        background: transparent;
        border: none;
        padding: 0rem 0.8rem;
        width: 100%;
        font-size: 0.8rem;
        margin: 0.4rem 0;
        border-right: 0.1rem solid #fff;
      }

      input::-webkit-input-placeholder {
        color: #ffffff;
      }
    }

    .dropdown-menu {
      padding: 0;
      background: #fff;
      border-radius: 0 !important;
    }

    .dropdown:hover > .dropdown-menu {
      display: block;
    }

    .dropdown > .dropdown-toggle:active {
      pointer-events: none;
    }

    .dropdown > .dropdown-toggle::after {
      border: none;
    }

    .navbar-expand-lg .navbar-nav .nav-link {
      padding-right: 1rem !important;
      padding-left: 1rem !important;
    }

    .dropdown-toggle::after {
      display: none;
    }

    .dropdown-menu {
      text-align: center;
      transform: translateX(25px);
    }
  }
}
</style>